import styled from "styled-components";

export const AmountSummarySection = styled.div`
  margin-top: 18px;
`;

export const AmountSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AmountBreakdownRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
  margin-bottom: 0;
`;

export const AmountRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const TimelineSection = styled.div`
  margin-top: 18px;
`;

export const TimelineItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TimelineItemTitle = styled.div``;

export const TimelineItemSubTitle = styled.div``;

export const TimelineItemDetailRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TimelineDetailRow = styled.div`
  display: flex;
  align-items: center;
`;

export const CopyButton = styled.button`
  appearance: none;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 6px;
`;

export const TimelineItemHelperText = styled.div``;
